import React from 'react'
import pageStyles from '../CreatorsProgramPage/styles.module.css'
import Text from '../../../Text'
import { $textPrimary, $textSecondary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import SpecsTable from '../../Products/Utils/ItemSpecifications/SpecsTable'

function Step1() {
  return (
    <div className={pageStyles.stepWrapper}>
      <div className={pageStyles.stepContentWrapper}>
        <div className={pageStyles.stepTitle}>
          <Text type="heading-1">01</Text>
        </div>
        <div className={pageStyles.stepTextWrapper}>
          <Text type="heading-2" color={$textPrimary.dark}>You submit</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Start your VRS Creators Program journey by submitting your best content featuring VRS hardware. Fill out the application form and upload your videos or photos that highlight your sim racing skills.</Text>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>What to submit?</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>You will have to fill a quick form</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>2 Vertical Shorts: 1080p resolution or higher, 30-40 seconds each</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Horizontal Video: 1080p resolution or higher, no less than 2 minutes.</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>10 High-Quality Images: Showcase the product from different angles.</Text>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>Social profile requirements</Text>
          <Spacer size={16}/>
          <SpecsTable specs={[
            { name: '15 000', value: 'Views for the past 12 months' },
            { name: '1500', value: 'Subscribers / Followers' },
          ]} theme="dark"/>
          <Spacer size={16}/>
          <Text type="small" color={$textSecondary.dark}>on Instagram, Twitter, YouTube, Facebook, or TikTok.</Text>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>Social profile requirements</Text>
          <Spacer size={16}/>
          <SpecsTable specs={[
            { name: 'Mar 30 2025', value: 'Submit by this day' }
          ]} theme="dark"/>
        </div>
      </div>
    </div>
  )
}

export default Step1
